import { postRequest } from "../RestServices";
import * as urls from "../../api/updateActiveUnits/url";
export const performActivation = async (payload) => {
  try {
    return await postRequest(urls.ACTIVATE_UNITS, payload);
  } catch (err) {
    return err;
  }
};
